import Vue from "vue";
import Router from "vue-router";
import Scenes from "./views/Scenes.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: Scenes
    },
    {
      path: "/scenes",
      name: "scenes",
      component: Scenes
    },
    {
      path: "/scene/:id",
      name: "scene",
      component: () =>
        import(/* webpackChunkName: "scene" */ "./views/Scene.vue"),
      props: route => ({ id: route.params.id })
    },    
    {
      path: "/models",
      name: "models",
      component: () =>
        import(/* webpackChunkName: "models" */ "./views/Models.vue")
    },
    {
      path: "/model/:id",
      name: "model",
      component: () =>
        import(/* webpackChunkName: "model" */ "./views/Model.vue"),
      props: route => ({ id: route.params.id })
    },    
    {
      path: "/studios",
      name: "studios",
      component: () =>
        import(/* webpackChunkName: "studios" */ "./views/Studios.vue")
    },
    {
      path: "/studio/:id",
      name: "studio",
      component: () =>
        import(/* webpackChunkName: "studio" */ "./views/Studio.vue"),
      props: route => ({ id: route.params.id })
    },
    {
      path: "/aliases/:alias",
      name: "aliases",
      component: () =>
        import(/* webpackChunkName: "scenesAliasSearch" */ "./views/Aliases.vue"),
      props: route => ({ alias: route.params.alias })
    },
    {
      path: "/galleries",
      name: "galleries",
      component: () =>
        import(/* webpackChunkName: "galleries" */ "./views/Galleries.vue")
    },
    {
      path: "/gallery/:id",
      name: "gallery",
      component: () =>
        import(/* webpackChunkName: "galery" */ "./views/Gallery.vue"),
      props: route => ({ id: route.params.id })
    },
    {
      path: "/tags",
      name: "tags",
      component: () =>
        import(/* webpackChunkName: "tags" */ "./views/Tags.vue")
    },
    {
      path: "/tag/:id",
      name: "tag",
      component: () =>
        import(/* webpackChunkName: "tag" */ "./views/Tag.vue"),
      props: route => ({ id: route.params.id })
    },
    {
      path: "/collections",
      name: "collections",
      component: () =>
        import(/* webpackChunkName: "collections" */ "./views/Collections.vue")
    },
    {
      path: "/collections/:id",
      name: "collection",
      component: () =>
        import(/* webpackChunkName: "collection" */ "./views/Collection.vue"),
      props: route => ({ id: route.params.id })
    }
  ]
});
